enum ActionTypes {
  PRODUCTS_SOURCE_REQUEST = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_REQUEST',
  PRODUCTS_SOURCE_SUCCESS = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_SUCCESS',
  PRODUCTS_SOURCE_FAILURE = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_FAILURE',
  PRODUCTS_SOURCE_FAVORITE = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_FAVORITE',
  PRODUCTS_SOURCE_FAVORITE_REQUEST = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_FAVORITE_REQUEST',
  PRODUCTS_SOURCE_FAVORITE_SUCCESS = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_FAVORITE_SUCCESS',
  PRODUCTS_SOURCE_FAVORITE_FAILURE = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_FAVORITE_FAILURE',
  SET_PRODUCT_NOTE = 'app/LandingPage/KamereoFresh/SET_PRODUCT_NOTE',
  SET_PRODUCT_NOTE_REQUEST = 'app/LandingPage/KamereoFresh/SET_PRODUCT_NOTE_REQUEST',
  SET_PRODUCT_NOTE_SUCCESS = 'app/LandingPage/KamereoFresh/SET_PRODUCT_NOTE_SUCCESS',
  SET_PRODUCT_NOTE_FAILURE = 'app/LandingPage/KamereoFresh/SET_PRODUCT_NOTE_FAILURE',
  GET_MORE_SECTION_DATA = 'app/LandingPage/KamereoFresh/GET_MORE_SECTION_DATA',
  PRODUCTS_SOURCE_INIT = 'app/LandingPage/KamereoFresh/PRODUCTS_SOURCE_INIT',
  CONTACT_US_SUBMIT = 'app/LandingPage/KamereoFresh/CONTACT_US_SUBMIT',
  CONTACT_US_REQUEST = 'app/LandingPage/KamereoFresh/CONTACT_US_REQUEST',
  CONTACT_US_SUCCESS = 'app/LandingPage/KamereoFresh/CONTACT_US_SUCCESS',
  CONTACT_US_FAILURE = 'app/LandingPage/KamereoFresh/CONTACT_US_FAILURE',
  CONTACT_US_SHORT_FORM_REQUEST = 'app/LandingPage/KamereoFresh/CONTACT_US_SHORT_FORM_REQUEST',
}

export default ActionTypes;
